export const jingles = [
  {
    name: "Smooth.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Smooth.mp3"
  },
  {
    name: "Abenteurlich.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Abenteurlich.mp3"
  },
  {
    name: "Aufregend.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Aufregend.mp3"
  },
  {
    name: "Business.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Business.mp3"
  },
  {
    name: "Inspirierend.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Inspirierend.mp3"
  },
  {
    name: "Intensiv.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Intensiv.mp3"
  },
  {
    name: "Nostalgisch.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Nostalgisch.mp3"
  },
  {
    name: "Ruhig.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Ruhig.mp3"
  },
  {
    name: "Sonnig.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Sonnig.mp3"
  },
  {
    name: "Süß.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Su%CC%88%C3%9F.mp3"
  },
  {
    name: "Vergnügt.mp3",
    url: "https://storage.googleapis.com/talentbait-tts-files/Jingles/Vergnu%CC%88gt.mp3"
  },
  { name: "No_Sound.mp3", url: "" }
];

export const DEFAULT_JINGLES = jingles.map(({ name, url }) => ({
  value: url,
  label: name.replace(".mp3", "").replace("_", " ")
}));

export const LIMIT_FIELD_CHARACTERS = {
  title: 104,
  benefits: 55,
  CTAText: 28,
  outroText: 30
};
